/**
 * Contains functions commonly used in different js files
 */
class AssessmentHelper {
    public isCorrectAnswer(): boolean {
        const $container = $('.survey-item');
        const selectedAnswer = Number($('input:checked', $container).val());
        const correctAnswer = $container.data('correct-answer');
        return correctAnswer === selectedAnswer;
    };
}

export default new AssessmentHelper();
